<template>
    <div id="confirmation" class="page">

      <!-- <div class="confirmation-confetti-bg">
        <canvas id="confirmationConfettiBgCanvas" ref="confirmationConfettiBgCanvas"></canvas>
      </div> -->

      <div class="confirmation-content">
      <div class="head-wrapper">
        <h2 class="head-copy in">You've Won!</h2>
      </div>

      <div class="stage-wrapper">
        <div class="egg-spacer"></div>
        <p class="sub-copy in">We've Received Your Submission. YOUR EASTER TREAT IS HOPPING YOUR WAY!</p>
      </div>
      </div>

    </div>
</template>

<script>
import { mapMutations } from 'vuex';
// import confetti from 'canvas-confetti';

export default {
  name: 'Confirmation',

  mounted() {
    this.fireConfetti();
    // this.confirmationConfetti = confetti.create(this.$refs.confirmationConfettiBgCanvas, {resize:true});
    

    // this.confirmationConfetti({
    //   particleCount: 100,
    //   spread: 35,
    //   startVelocity: 60,
    //   ticks: 300,
    //   colors: ['#fe5200', '#551e0a', '#fdef14'],
    //   origin: {
    //     y: 1.0,
    //   }
    // })

    // this.fireConfetti({
    //   particleCount: 50,
    //   spread: 50,
    //   startVelocity: 60,
    // });

    // this.fireConfetti({
    //   particleCount: 30,
    //   spread: 35,
    //   startVelocity: 50
    // });

    // this.fireConfetti({
    //   particleCount: 20,
    //   spread: 40,
    //   decay: 0.8
    // });
  },

  methods: {
    ...mapMutations([
      'showConfetti',
    ]),

    fireConfetti() {
      console.log('Confirmation fireConfetti()');
      this.showConfetti();
    },

    // fireConfetti(opts) {
    //   let defaults = {
    //     particleCount: 100,
    //     spread: 35,
    //     startVelocity: 60,
    //     ticks: 300,
    //     colors: ['#fe5200', '#551e0a', '#fdef14'],
    //     origin: {
    //       y: 1.0,
    //     }
    //   }

    //   let options = Object.assign(defaults, opts);
    //   console.log(options);

    //   this.confirmationConfetti(options);
    // }
  }
}
</script>

<style lang="scss">

.confirmation-content {
  position: relative;
  
}

.confirmation-confetti-bg {
  position: absolute;
  top: 0;
  left: 50%;
  width: 110%;
  height: 100%;
  transform: translateX(-50%);

  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>